
import { getDefaultAirport } from 'selectors/flightsSelectors'
import { useAppSelector } from './reduxHooks'

function useDefaultAirport() {
  return useAppSelector(getDefaultAirport)
}

export default useDefaultAirport
